export default __webpack_public_path__ + "static/media/toy.7411ccfb.png";